<template>
    <div>
        <template
            v-if="adjustments?.length"
        >
            <ul
                class="ma-0 mt-2 pa-0 list-style-none"
            >
                <li
                    v-for="(adj, index) in adjustments"
                    :key="index"
                    class=""
                >
                    <span
                        class="d-inline-block mr-1"
                    >
                        <v-icon
                            color="secondary"
                            size="18"
                            :icon="mdiTagPlus"
                        ></v-icon>
                    </span>
                    <span
                        class="text-label-medium text-uppercase letter-spacing-6"
                    >
                        {{ adj.description }}
                    </span>
                    <template
                        v-if="adj.amount > 0"
                    >
                        <span
                            class="ml-1 font-weight-bold"
                        >
                            ({{ formatCurrency(adj.amount) }})
                        </span>
                    </template>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import type { CartAdjustment } from '~/types';
    import { formatCurrency } from 'x1-base/utils';
    import { mdiTagPlus } from '@mdi/js';

    defineProps<{
        adjustments?: Nilish<CartAdjustment[]>;
    }>();
</script>

<style lang="scss" scoped></style>
